"use strict";
import React from "react";
import login from "./login";

const initComponent = (flex = window.flex) => {

    const Login = login(flex);

    class Splash extends React.PureComponent {
        render() {
            const session = this.props.session;
            if (!flex.appLoaded()) return false;
            return (
                <div>
                    <header id="top" className="page-header" role="banner">
                        <div className="container top-container">
                            <a href="#" className="logo"></a>
                        </div>
                    </header>
                    <Login />
                </div>
            );
        }
    }

    return Splash;
};

module.exports = initComponent;
